shadow$provide[426] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform float pointSize;

float getPointSize(vec4 xyzw) {
  return pointSize;
}`;

};